// Category → accent colour token (Tailwind arbitrary values use the design-system palette)
//
// Shared between LibraryPage (card badge/border/gradient) and
// ScenarioBriefingPage (badge only — the briefing hero wash stays teal to
// match the chat Scenario pane's fallback gradient), so a scenario shows the
// same accent on its library card as on its own badge.
export const CATEGORY_STYLES: Record<
  string,
  { badge: string; border: string; gradient: string }
> = {
  "Customer Retention": {
    badge: "bg-primary/10 text-primary border-primary/20",
    border: "border-primary",
    gradient: "from-primary/20 via-primary/5 to-transparent",
  },
  "Risk Management": {
    badge: "bg-error/10 text-error border-error/20",
    border: "border-error",
    gradient: "from-error/20 via-error/5 to-transparent",
  },
  "Capital Strategy": {
    badge: "bg-tertiary/10 text-tertiary border-tertiary/20",
    border: "border-tertiary",
    gradient: "from-tertiary/20 via-tertiary/5 to-transparent",
  },
  "M&A Strategy": {
    badge: "bg-secondary/10 text-secondary border-secondary/20",
    border: "border-secondary",
    gradient: "from-secondary/20 via-secondary/5 to-transparent",
  },
};

export const DEFAULT_CATEGORY_STYLE = {
  badge: "bg-primary/10 text-primary border-primary/20",
  border: "border-primary",
  gradient: "from-primary/20 via-primary/5 to-transparent",
};

export function categoryStyle(category: string) {
  return CATEGORY_STYLES[category] ?? DEFAULT_CATEGORY_STYLE;
}
